<template>
  <div>
    <Dialog
      :key="columnSelectionDialogKey"
      :visible.sync="columnSelectionDialog1"
      :style="{ width: '640px', overflowY: 'auto' }"
      header="Columns to show in the data table"
      :modal="true"
      class="p-fluid"
    >
      <DataTable
        :value="fieldsToShow"
        :reorderableColumns="true"
        @row-reorder="onRowReorder"
        editMode="cell"
        class="editable-cells-table"
        responsiveLayout="scroll"
      >
        <Column
          :rowReorder="true"
          headerStyle="width: 3rem"
          :reorderableColumn="false"
        />
        <Column field="active" header="Active?" headerStyle="width: 3em">
          <template #body="slotProps">
            <ToggleButton
              :disabled="!!slotProps.data.alwaysShow"
              :title="slotProps.data.alwaysShow ? 'Always shown: it can be moved but not hidden' : ''"
              v-model="slotProps.data['active']"
              onIcon="pi pi-check"
              offIcon="pi pi-times"
              style="height: 30px;"
            />
          </template>
          <template #editor="slotProps">
            <ToggleButton
              :disabled="!!slotProps.data.alwaysShow"
              v-model="slotProps.data['active']"
              onIcon="pi pi-check"
              offIcon="pi pi-times"
              style="height: 30px;"
            />
          </template>
        </Column>
        <Column
          field="fieldName"
          header="Field Name"
          headerStyle="width: 7em"
        ></Column>
        <!-- <Column 
          field="width" 
          header="Width"
          headerStyle="width: 7em"
        >
          <template #body="slotProps">
            {{ slotProps.data['width'] }}
            <Slider v-model="slotProps.data['width']"/>
          </template>
          <template #editor="slotProps">
            {{ slotProps.data['width'] }}
            <Slider v-model="slotProps.data['width']"/>
          </template>
        </Column> -->
      </DataTable>

      <template #footer>
        <ProgressSpinner
          v-if="resettingColumns"
          style="float: left; width:25px; height:25px; width: 100px;"
          strokeWidth="5"
          fill="#EEEEEE"
          animationDuration=".5s"
        />
        <Button
          v-else
          style="float: left;"
          label="Reset"
          class="p-button-info"
          @click="$emit('resetCols')"
        />
        <Button
          label="Cancel"
          icon="pi pi-times"
          class="p-button-danger"
          style="width: 100px;"
          @click="$emit('close')"
        />
        <ProgressSpinner
          v-if="sendingRequest"
          style="width:25px; height:25px; width: 100px;"
          strokeWidth="5"
          fill="#EEEEEE"
          animationDuration=".5s"
        />
        <Button
          v-else
          label="Save"
          icon="pi pi-check"
          class="p-button-success"
          style="width: 100px;"
          @click="save"
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
import FiltersService from "../../../service/FiltersSerice";

import { columnSelectionRequest } from "../sendRequest";

export default {
  name: "columnSelection",
  props: {
    columnSelectionDialog: {
      type: Boolean,
      required: true
    },
    dbViewFields: {
      type: Array,
      required: false
    },
    dbView: {
      type: Number,
      required: true
    },
    selectionToEdit: {
      type: Array,
      required: false
    },
    reloadComponent: {
      type: Number,
      required: true
    },
    resettingColumns: {
      type: Boolean,
      required: false
    }
  },
  data: () => ({
    filtersService: new FiltersService(),
    columnSelectionDialogKey: 0,
    sendingRequest: false,
    fieldsToShow: [],
    selected: []
  }),
  computed: {
    columnSelectionDialog1: {
      set(val) {
        if (!val) {
          this.$emit("close");
        }
      },
      get() {
        return this.columnSelectionDialog;
      }
    }
  },
  watch: {
    reloadComponent() {
      this.setupComponent();
      this.columnSelectionDialogKey++;
    }
  },
  methods: {
    setupComponent() {
      this.fieldsToShow = [];
      this.selected = [];

      console.log(this.selectionToEdit, this.dbViewFields);

      // first add used fields
      this.selectionToEdit.forEach(a => {
        if (a.dbField && a.dbField.canShow) {
          this.fieldsToShow.push({
            ...a.dbField,
            active: true,
            width: Math.round((a.width / 300) * 100)
          });
        }
      });

      // F1: an always-shown field (the enquiry Status) is always ticked; missing from the choice, it comes next
      this.dbViewFields.forEach(a => {
        if (a.canShow && a.alwaysShow && !this.fieldsToShow.some(b => b.id === a.id)) {
          this.fieldsToShow.push({
            ...a,
            active: true,
            width: Math.round((a.defWidth / 300) * 100)
          });
        }
      });

      // then unused
      this.dbViewFields.forEach(a => {
        if (a.canShow) {
          let found = this.fieldsToShow.find(b => b.id === a.id);
          if (found < 0 || !found) {
            this.fieldsToShow.push({
              ...a,
              active: false,
              width: Math.round((a.defWidth / 300) * 100)
            });
          }
        }
      });
    },
    onRowReorder(event) {
      //

      for (let i = 0; i < event.value.length; i++) {
        let a = this.fieldsToShow.findIndex(b => b.id === event.value[i].id);
        if (a !== i) {
          if (event.value[i].active) {
            this.fieldsToShow = event.value;
          } else {
            this.$toast.add({
              severity: "warn",
              summary: "Inactive column",
              detail: `Please activate this column to be used.`,
              life: 2000
            });
          }
          break;
        }
      }
    },
    /** The columns to save: the ticked ones, and always the always-shown ones. */
    chosen() {
      this.fieldsToShow.forEach(a => {
        if (a.active || a.alwaysShow) {
          this.selected.push(a);
        }
      });
    },
    save() {
      this.chosen();

      this.sendingRequest = true;

      columnSelectionRequest(this, "columnSelection.vue");
    }
  }
};
</script>

<style></style>
